import { useLocalStore } from 'mobx-react-lite';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';
import { Group } from 'STORE/Groups/Group';
import { TextPayload } from 'STORE/Messages/Message/Payload/TextPayload/TextPayload';

interface IBotCommandRendererPresenter {
  group: Group | null;
  onClick(): void;
}

export const useBotCommandRendererPresenter = (command: string): IBotCommandRendererPresenter => {
  const presenter = useLocalStore(() => ({
    get group(): Group | null {
      return Entities.GroupsStore.activeGroup;
    },

    onClick(): void {
      if (!presenter.group) {
        return;
      }

      Tasks.messaging.createNewMessages(presenter.group.id, [
        {
          payload: new TextPayload({ text: command }),
        },
      ]);
    },
  }));

  return presenter;
};
